export default "__VITE_ASSET__CdxbOEie__"